import React, { createContext, ReactNode, useState } from "react";

import { Type_Category_Row } from "src/components/settings/CategoryView";
import { Type_Map_Formatted } from "src/types/map";
import { Type_User } from "src/types/user";

const SettingContext = createContext<{
    user: Type_User | null;
    updateUser: (value: Type_User | null) => void;
    map: Type_Map_Formatted | null;
    updateMap: (value: Type_Map_Formatted | null) => void;
    category: Type_Category_Row | null;
    updateCategory: (value: Type_Category_Row | null) => void;
}>({
    user: null,
    updateUser: () => {},
    map: null,
    updateMap: () => {},
    category: null,
    updateCategory: () => {},
});

type SettingContextProviderProps = {
    children: ReactNode;
};

const SettingContextProvider = ({ children }: SettingContextProviderProps) => {
    const [user, setUser] = useState<Type_User | null>(null);
    const [map, setMap] = useState<Type_Map_Formatted | null>(null);
    const [category, setCategory] = useState<Type_Category_Row | null>(null);

    const updateUser = (user: Type_User | null) => {
        setUser(user);
    };

    const updateMap = (map: Type_Map_Formatted | null) => {
        setMap(map);
    };

    const updateCategory = (category: Type_Category_Row | null) => {
        setCategory(category);
    };

    return (
        <SettingContext.Provider
            value={{
                user,
                updateUser,
                map,
                updateMap,
                category,
                updateCategory,
            }}
        >
            {children}
        </SettingContext.Provider>
    );
};

export { SettingContext, SettingContextProvider };
